import * as tslib_1 from "tslib";
import * as React from 'react';
import { Card, CardHeader } from 'material-ui/Card';
var styles = {
    header: {
        textOverflow: 'ellipsis',
    },
    title: {
        textOverflow: 'ellipsis',
    },
    item: {
        margin: '1rem auto',
        padding: '0',
        color: '#414141',
        cursor: 'pointer',
        width: '25%'
    },
    text: {
        fontSize: '12px',
        paddingRight: 0,
    },
};
var NfcProjects = /** @class */ (function (_super) {
    tslib_1.__extends(NfcProjects, _super);
    function NfcProjects(props) {
        var _this = _super.call(this, props) || this;
        _this.handleProjectSelect = function (projectID) {
            _this.props.onItemClick(projectID);
        };
        return _this;
    }
    NfcProjects.prototype.render = function () {
        var _this = this;
        return React.createElement("div", { onClick: function (e) { return _this.handleProjectSelect(_this.props.nfcTask.projectId); } },
            React.createElement(Card, { style: styles.item },
                React.createElement(CardHeader, { textStyle: styles.text, style: styles.header, titleStyle: styles.title, title: this.props.nfcTask.projectName, subtitle: "Feladatok: " + this.props.nfcTask.tasks.length })));
    };
    return NfcProjects;
}(React.Component));
export default NfcProjects;



//////////////////
// WEBPACK FOOTER
// ./src/pages/nfctask/NfcProjects.tsx
// module id = 806
// module chunks = 0